// import React from "react";
import "./PageNotFound.scss";
import { Link } from "react-router-dom";

const PageNotFound = () => {
  return (
    <div className="page-not-found-parent-div">
      <p className="page-not-found-heading-404">404</p>

      <img src="/assets/img/404-page-not-found.gif" />
      <p className="page-not-found-heading">Look like you're lost!</p>
      <p className="page-not-found-sub-heading">
        The page you are looking for not available!
      </p>
      <div className="d-flex justify-content-center">
        <Link to="/">
          <button
            style={{ backgroundColor: "green", marginTop: "10px" }}
            className="btn_fill"
          >
            Go To Home
          </button>
        </Link>
      </div>
    </div>
  );
};

export default PageNotFound;
